import {useSelector} from "react-redux";
import {TYPE_CCATS} from "../../store/account/constants";

const PriorCamperInfo = () => {
    const { form, errors, disabled } = useSelector((state) => state.register);
    const programType = useSelector((state) => state.account.programType);

    return (
        <div style={{width: "100%", margin: "0 auto"}}>
            <h2>{form.firstName} {form.lastName} {"\u2022"} {form.sex} {"\u2022"} {programType === TYPE_CCATS ? ("Grade " + form.grade) : new Date(form.birthdate).toLocaleDateString()}</h2>
        </div>
    )
}

export default PriorCamperInfo;
